import { Injectable } from '@angular/core';
import { VesselService } from './vessel.service';
import { HttpRequest } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class VesselEditGuardService {
    constructor(private vesselService: VesselService) {}

    canEdit(req: HttpRequest<any>) {
        if (req.method === 'GET' || req.body?.skipGuard) {
            return true;
        }
        if (!this.vesselService.getActiveVesselId()) {
            return true;
        }
        return this.vesselService.canEditVessel;
    }
}
